// src/app/app.config.ts
import { provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig, provideZoneChangeDetection, APP_INITIALIZER, inject } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { routes } from './app.routes';
import { GraphService } from '../app/services/graph/graph.service';
import { RolesService } from '../app/services/roles.service';

function initApp() {
  const graph = inject(GraphService);
  const roles = inject(RolesService);

  return async () => {
    // 1) Carrega e salva os dados do Graph (inclui employeeId)
    await graph.saveGraphUserData();

    // 2) Usa o employeeId como SSB
    const ssb = graph.getSavedUserData()?.employeeId?.trim();
    if (!ssb) {
      console.warn('SSB (employeeId) não encontrado no Graph. Prosseguindo sem roles.');
      return;
    }

    // 3) Busca as roles do usuário
    await roles.loadAtStartup(ssb);
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(withFetch(), withInterceptorsFromDi()),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withComponentInputBinding()),
    provideAnimationsAsync(),
    { provide: APP_INITIALIZER, useFactory: initApp, multi: true }
  ]
};
